import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/hospitality/')({
  beforeLoad: () => {
    throw redirect({ to: '/hospitality/reservations' })
  },
})
